const UPPER_START = 65;
const UPPER_END = 90;

const buildAlphaNumeric = () => {
  const result: Record<string, any> = {};
  let ch;
  for (let i = UPPER_START; i <= UPPER_END; i++) {
    ch = String.fromCharCode(i);
    result[ch] = ["letterInput", ch];
  }
  return result;
};

export default {
  base: {
    advance: ["submitWord", null],
  },
  target: {
    advance: ["confirmTarget", null],
    cancel: ["cancelTarget", null],
  },
  move: {
    up: ["move", { x: 0, y: -1 }],
    left: ["move", { x: -1, y: 0 }],
    right: ["move", { x: 1, y: 0 }],
    down: ["move", { x: 0, y: 1 }],
    mouseTile: ["mouseTileMove", null],
  },
  playerActions: {
    backspace: ["backspace", null],
    swapDirection: ["swapDirection", null],
    advance: ["submit", null],
    cheat: ["cheat", null],
    spellList: ["spellList", null],
    wait: ["wait", null],
  },
  letters: buildAlphaNumeric(),
} as const;
